import React from 'react';
import { styled, SvgIcon } from '@teko/ui';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledDetailNavBar = styled.div`
  display: flex;
  height: 3.5rem;
  background: #fff;
  align-items: center;
  justify-content: space-between;
  &.detail {
    box-shadow: none;
  }
`;
const Left = styled.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Right = styled.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
`;
const DetailNavBar = (_a) => {
  var _b = _a, {
    right,
    goBack
  } = _b, props = __objRest(_b, [
    "right",
    "goBack"
  ]);
  return /* @__PURE__ */ React.createElement(StyledDetailNavBar, __spreadValues({}, props), /* @__PURE__ */ React.createElement(Left, null, /* @__PURE__ */ React.createElement(SvgIcon, {
    name: "chevron-back",
    size: 24,
    onClick: goBack,
    color: "#333"
  })), /* @__PURE__ */ React.createElement(Right, null, right));
};

export { DetailNavBar };
